import { render, staticRenderFns } from "./DispatcherRow.vue?vue&type=template&id=32a37c42&scoped=true&"
import script from "./DispatcherRow.vue?vue&type=script&lang=js&"
export * from "./DispatcherRow.vue?vue&type=script&lang=js&"
import style0 from "./DispatcherRow.vue?vue&type=style&index=0&id=32a37c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a37c42",
  null
  
)

export default component.exports